import { Component, OnInit } from "@angular/core";
import { PwaService } from "./shared/services/pwa.service";
import { CustomerInput } from "./shared/model/customer.model";
import { Subscription } from "rxjs";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { CustomerService } from "./shared/services/customer.service";
import { OrderService } from "./shared/services/order.service";
import { ReservationInput } from "./shared/model/reservation.model";
import { SimpleCookieService } from "./shared/services/simple-cookie.service";
import { COOKIE_STORAGE } from "./shared/constants/cookie.constants";
import { environment } from "src/environments/environment";
import { LocalStorageService } from "./shared/services/local-storage.service";
import { LOCAL_STORAGE } from "./shared/constants/local-storage.constants";
import { filter, take } from 'rxjs/operators';
import { SessionStorageService } from "./shared/services/session-storage.service";
import { SESSION_STORAGE } from "./shared/constants/session-storage.constants";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";

@Component({
	selector: "app-root",
	templateUrl: "app.component.html",
	styleUrls: ["app.component.scss"],
	standalone: true,
	imports: [IonicModule, CommonModule, FormsModule],
})
export class AppComponent implements OnInit {
	customerId: any;
	customerDetails: CustomerInput | undefined;

	constructor(
		private pwasService: PwaService,
		private route: ActivatedRoute,
		private cookie: SimpleCookieService,
		private customerService: CustomerService,
		private router: Router
	) { }

	ngOnInit() {
		this.router.events.pipe(
			filter((event) => event instanceof NavigationEnd), take(1)
		).subscribe((event: NavigationEnd) => {
			SessionStorageService.setValue(SESSION_STORAGE.PREVIOUS_URL, SessionStorageService.getValue(SESSION_STORAGE.CURRENT_URL))
			SessionStorageService.setValue(SESSION_STORAGE.CURRENT_URL, event.url)
		});
		this.route.queryParams.subscribe((params) => {
			this.customerId = params["customerId"];

			if (this.customerId !== undefined) {
				this.customerService.getCustomerById(this.customerId).subscribe(
					(result: any) => {
						if (result) {
							this.customerDetails = result.data.GetCustomerById
							this.customerService.setCustomerDetails(
								result.data.GetCustomerById,
							);
							this.setCookies();
						}

						// this.loading.dismiss();
						LocalStorageService.setValue(
							LOCAL_STORAGE.CUSTOMER_DETAILS,
							JSON.stringify(result.data.GetCustomerById),
						);
					},
					(error: Error) => {
						console.log(error.message);
					},
				);
			}
		});
	}

	setCookies() {
		if (!this.customerDetails) {
			return;
		}

		let additionalInfo: any = {
			name: this.customerDetails.name,
			id: this.customerDetails.id,
		};

		let dataStringify: any = JSON.stringify({
			additionalInfo: additionalInfo,
			username: this.customerDetails.phoneNumber,
		});
		this.cookie.set(
			COOKIE_STORAGE.TOKEN,
			dataStringify,
			true,
			environment.COOKIE_KEY,
			COOKIE_STORAGE.EXPIRY,
			"",
			"",
			true,
			"Strict",
		);
	}
}
